class PlanSelector {
  
  plan_type=null;
  selected_structured_plan=null;
  selected_flexible_plan=null;
  selected_plan=null;
  selected_variant=null;
  program_duration=null;
  program_type=null;
  order_attributes=null;

  constructor() {
    this.order_attributes = new URLSearchParams(window.location.search);
    this.selected_structured_plan = window.plan_details.find(plan=>plan.handle=='signature-program' && plan.duration == '7 Days' && plan.type == 'Full Program' && plan.snack_count == 0);
    this.selected_flexible_plan = window.plan_details.find(plan=>plan.handle.includes('flexible-program') && plan.meal_count == window.order_defaults.mealCount);
    this.plan_type = window.order_defaults.planType;
    const query_string = window.location.href.toLowerCase().split("#")[1];
    if (query_string) {
      const plan_requested = query_string.split("&")[0];
      const variant_requested = query_string.split("&")[1];
      const snack_step = query_string.split("&")[2] === "select-snacks" ? true : false;
      var duration = "";
      var type = "";
      this.plan_type = plan_requested.startsWith("flexible") ? "flexible" : "structured";

      if (this.plan_type == 'flexible') {
        if (/\d$/.test(plan_requested)) {
          this.selected_flexible_plan = window.plan_details.find(plan=>plan.handle==plan_requested && plan.handle.includes('flexible'));
        }
        if (!this.selected_flexible_plan) {
          this.selected_flexible_plan = window.plan_details.find(plan=>plan.handle.includes('flexible-program') && plan.meal_count == window.order_defaults.mealCount);
        }
      } else if (variant_requested) {
        const meals_requested = variant_requested.split("_")[0];
        if (meals_requested == "ld") {
          type = "Lunches & Dinners";
        } else {
          type = "Full Program";
        }
        const days_requested = variant_requested.split("_")[1];
        if (days_requested == "5") {
          duration = "5 Days";
        } else {
          duration = "7 Days";
        }
        this.selected_structured_plan = window.plan_details.find(plan=>plan.handle==plan_requested && plan.duration == duration && plan.type == type && plan.snack_count == 0);
      } else {
        const program_type = plan_requested == "vegan-program" ? 'Lunches & Dinners' : 'Full Program';
        this.selected_structured_plan = window.plan_details.find(plan=>plan.handle==plan_requested && plan.duration == '7 Days' && plan.type == program_type && plan.snack_count == 0);
      }
      if (snack_step && !window.snack_upsell_disabled && plan_requested != "vegan-program") {
        document.querySelectorAll('.js-plan-step').forEach(el => {
          el.classList.remove('active');
        });
        document.querySelectorAll('.js-snack-step').forEach(el => {
          el.classList.add('active');
        });
        document.getElementById('order-anchor').scrollIntoView();
      }
    }

    if (!this.selected_structured_plan) {
      this.selected_structured_plan = window.plan_details[0];
    }
    if (!this.selected_flexible_plan) {
      this.selected_flexible_plan = window.plan_details[76];
    }
    
    this.selected_variant = this.selected_structured_plan.id;
    this.program_duration  = this.selected_structured_plan.duration;
    this.program_type  = this.selected_structured_plan.type;
    this.plan_snacks = this.selected_structured_plan.snack_count;
    this.setupEvents();
    this.render();
  }

  setupEvents() {
    document.querySelectorAll(".js-tab-btn").forEach(tabBtn => {
      tabBtn.addEventListener("click", event => {
        const element = event.currentTarget;
        const selected = element.getAttribute('aria-selected');
        if (selected === "false") {
          this.plan_type = element.getAttribute('aria-controls');
          this.render();          
          const url = this.plan_type === 'structured' ? "#" + this.selected_structured_plan.handle + "&" + this.selected_structured_plan.meals + "_" + this.selected_structured_plan.days : "#" + this.selected_flexible_plan.handle;
          window.history.pushState({}, '', url);
        }
      });
    });

    document.querySelectorAll(".single-flexible-product").forEach(prog=>{
      prog.addEventListener("click",()=>{
        this.select_flexible_plan(parseInt(prog.getAttribute("data-product-id")));
        const url = "#" + prog.getAttribute("data-handle");
        window.history.pushState({}, '', url);
      });
    });

    document.querySelectorAll(".single-plan-product").forEach(prog=>{
      prog.addEventListener("click",()=>{
        this.select_program(parseInt(prog.getAttribute("data-product-id")));
        const url = "#" + prog.getAttribute("data-handle") + "&" + this.selected_structured_plan.meals + "_" + this.selected_structured_plan.days;
        window.history.pushState({}, '', url);
      });
    });

    document.querySelectorAll(".variant-option[name='length']").forEach(radio=>{
      radio.addEventListener("click",event=>{
        this.update_duration(event.target.value);
        const url = "#" + this.selected_structured_plan.handle + "&" + this.selected_structured_plan.meals + "_" + radio.getAttribute("data-handle");
        window.history.pushState({}, '', url);
      });
    });

    document.querySelectorAll(".variant-option[name='type']").forEach(radio=>{
      radio.addEventListener("click",event=>{
        this.update_type(event.target.value);
        const url = "#" + this.selected_structured_plan.handle + "&" + radio.getAttribute("data-handle") + "_" + this.selected_structured_plan.days;
        window.history.pushState({}, '', url);
      });
    });

    document.querySelectorAll(".variant-option[name='type'][value='Full Program']").forEach(radio=>{
      radio.addEventListener("click",this.check_type.bind(this));
      radio.nextElementSibling?.addEventListener("mouseenter",this.check_type.bind(this));
      radio.nextElementSibling?.addEventListener("mouseleave",this.check_type.bind(this));
    });

    document.querySelectorAll(".variant-option[name='snacks']").forEach(input=>{
      input.addEventListener("click",async event=>{
        event.preventDefault();
        document.getElementById('decline-snacks-btn').classList.add('button--loading');

        this.update_snacks(event.target.value);

        const addToCartForm = document.querySelector("form[action$='/cart/add']");
        const formData = new FormData(addToCartForm);

        await this.clear_cart();
        await this.add_to_cart(formData);

        const returnToUrl = formData.get("return_to") || "/checkout";
        window.location.href = returnToUrl;
      });
    });

    document.getElementById('select-plan-btn').addEventListener("click", async event => {
      event.preventDefault();
      if (window.snack_upsell_disabled || this.plan_type === 'flexible' || (this.plan_type === 'structured' && this.selected_structured_plan.handle == 'vegan-program')) {
        event.currentTarget.classList.add('button--loading');

        const addToCartForm = document.querySelector("form[action$='/cart/add']");
        const formData = new FormData(addToCartForm);

        await this.clear_cart();
        await this.add_to_cart(formData);

        const returnToUrl = formData.get("return_to") || "/checkout";
        window.location.href = returnToUrl;
      } else {
        document.querySelectorAll('.js-plan-step').forEach(el => {
          el.classList.remove('active');
        });
        document.querySelectorAll('.js-snack-step').forEach(el => {
          el.classList.add('active');
        });
        document.getElementById('order-anchor').scrollIntoView();

        let url = window.location.href + '&select-snacks';
        const query_string = window.location.href.toLowerCase().split("#")[1];
        if (!query_string) {
          url = window.location.href + "#" + this.selected_structured_plan.handle + "&" + this.selected_structured_plan.meals + "_" + this.selected_structured_plan.days + '&select-snacks';
        }
        window.history.pushState({}, '', url);
      }
    });

    document.getElementById('decline-snacks-btn').addEventListener("click", async event => {
      event.preventDefault();
      event.currentTarget.classList.add('button--loading');

      const addToCartForm = document.querySelector("form[action$='/cart/add']");
      const formData = new FormData(addToCartForm);

      await this.clear_cart();
      await this.add_to_cart(formData);

      const returnToUrl = formData.get("return_to") || "/checkout";
      window.location.href = returnToUrl;
    });

    document.getElementById('back-to-plan-btn').addEventListener("click", () => {
      document.querySelectorAll('.js-plan-step').forEach(el => {
        el.classList.add('active');
      });
      document.querySelectorAll('.js-snack-step').forEach(el => {
        el.classList.remove('active');
      });
      document.getElementById('order-anchor').scrollIntoView();
      
      let url = window.location.href;
      url = url.replace("&select-snacks", "");
      window.history.pushState({}, '', url);
    });
  }

  render() {
    document.querySelectorAll(".js-tab-btn").forEach(btn=>{
      const planType = btn.getAttribute('aria-controls');
      const benefitsId = 'benefits-' + planType;
      if (this.plan_type === planType) {
        document.querySelectorAll(".js-tab-btn").forEach(tabBtn => {
          tabBtn.setAttribute("aria-selected","false");
        });
        btn.setAttribute("aria-selected", "true");
        document.querySelectorAll(".js-plan-selections").forEach(planSelections => {
          planSelections.classList.remove('active');
          if (planSelections.id === planType) {
            planSelections.classList.add('active');
          }
        });
        document.querySelectorAll(".js-plan-benefits").forEach(planBenefits => {
          planBenefits.style.display = 'none';
          if (planBenefits.id === benefitsId) {
            planBenefits.style.display = 'block';
          }
        });
      }
    });

    document.querySelectorAll(".single-flexible-product").forEach(prog=>{
      if (prog.getAttribute("data-product-id")==this.selected_flexible_plan.id) {
        prog.setAttribute("checked","")
        prog.classList.add("checked");
        document.querySelectorAll(".flexible-pricing-wrapper .js-meals-count").forEach(el=>{
          el.innerHTML = prog.getAttribute("data-meals-count");
        });
      } else {
        prog.removeAttribute("checked");
        prog.classList.remove("checked");
      }
    });

    document.querySelectorAll(".single-plan-product").forEach(prog=>{
      if (prog.getAttribute("data-product-id")==this.selected_structured_plan.plan_id) {
        prog.setAttribute("checked","")
        prog.classList.add("checked");
        document.querySelector(".js-prod-description").innerHTML = prog.getAttribute("data-description");
      } else {
        prog.removeAttribute("checked");
        prog.classList.remove("checked");
      }
    });

    document.querySelectorAll(".variant-option[name='length']").forEach(radio=>{
      if (radio.value==this.program_duration) {
        radio.setAttribute("checked","");
        radio.classList.add("checked");
      } else {
        radio.removeAttribute("checked");
        radio.classList.remove("checked");
      }
    });

    document.querySelectorAll(".variant-option[name='type']").forEach(radio=>{
      if (radio.value==this.program_type) {
        radio.setAttribute("checked","");
        radio.classList.add("checked");
      } else {
        radio.removeAttribute("checked");
        radio.classList.remove("checked");
      }
    });

    document.querySelectorAll(".flexible-product-label").forEach(label=>{
      const inputId = label.getAttribute('for');
      const handle = document.getElementById(inputId).getAttribute('data-handle');
      const planDetails = window.plan_details.find(plan => plan.handle === handle);
      if (planDetails && planDetails.price_per_meal_before !== undefined) {
        const perMealPrice = label.querySelector('span.per-meal-price');
        if (perMealPrice) {
          perMealPrice.innerHTML = `$${planDetails.price_per_meal_before.toFixed(2)}/meal`;
        }
      }
    });

    const opt = document.querySelector('.variant-option[value="Full Program"]');
    const col = opt?.closest('.d-flex');
    if (this.selected_structured_plan.handle == 'vegan-program') {
      col.classList.add('unavailable');
    } else {
      col.classList.remove('unavailable');
    }

    console.log(this);

    const snack2Plan = window.plan_details.find(plan => plan.plan_id == this.selected_structured_plan.plan_id && plan.meals == this.selected_structured_plan.meals && plan.duration == this.selected_structured_plan.duration && plan.snack_count == 2);
    const snack2PriceBefore = snack2Plan?.compare_at - this.selected_structured_plan.compare_at;
    const snack2PriceAfter = snack2Plan?.price - this.selected_structured_plan.price;

    const snack3Plan = window.plan_details.find(plan => plan.plan_id == this.selected_structured_plan.plan_id && plan.meals == this.selected_structured_plan.meals && plan.duration == this.selected_structured_plan.duration && plan.snack_count == 3);
    const snack3PriceBefore = snack3Plan?.compare_at - this.selected_structured_plan.compare_at;
    const snack3PriceAfter = snack3Plan?.price - this.selected_structured_plan.price;

    if (this.plan_type === "flexible") {
      this.selected_plan = this.selected_flexible_plan;
    } else {
      this.selected_plan = this.selected_structured_plan;
    }
    document.querySelector(".js-plan-id").value=this.selected_plan.plan_id;
    document.querySelector(".js-variant-id").value=this.selected_plan.id;
    
    if (this.plan_snacks == 0) {
      document.querySelector("input#selling_plan").value = this.selected_plan.selling_plan_id;

      document.querySelectorAll(".weekly-total").forEach(el => {
        el.innerHTML = `$${this.selected_plan.recurring_price.toFixed(2)}`;
      });
      document.querySelectorAll(".compare-price").forEach(el => {
        el.innerHTML = `$${this.selected_plan.compare_at.toFixed(2)}`;
      });
      document.querySelectorAll(".per-meal-before").forEach(el => {
        el.innerHTML = `$${this.selected_plan.price_per_meal_before.toFixed(2)}`;
      });
      document.querySelectorAll(".per-meal-after").forEach(el => {
        el.innerHTML = `$${this.selected_plan.price_per_meal_after.toFixed(2)}`;
      });
      document.querySelectorAll(".program-price").forEach(el => {
        el.innerHTML = `$${this.selected_plan.price.toFixed(2)}`;
      });
      document.querySelectorAll(".program-price-savings").forEach(el => {
        el.innerHTML = `$${this.selected_plan.savings.toFixed(2)}`;
      });

      document.querySelector(".plan-includes").innerHTML = this.selected_structured_plan.includes;
      document.querySelector(".js-snack-count-2").innerHTML = this.selected_structured_plan.duration == "5 Days" ? "10" : "14";
      document.querySelector(".js-snack-count-3").innerHTML = this.selected_structured_plan.duration == "5 Days" ? "15" : "21";
      document.querySelector(".js-compare-at-snack-price-2").innerHTML = snack2PriceBefore.toFixed(2);
      document.querySelector(".js-new-snack-price-2").innerHTML = snack2PriceAfter.toFixed(2);
      document.querySelector(".js-compare-at-snack-price-3").innerHTML = snack3PriceBefore.toFixed(2);
      document.querySelector(".js-new-snack-price-3").innerHTML = snack3PriceAfter.toFixed(2);
    }

    const formNode = document.getElementById('selling_plan');
    this.order_attributes.forEach((value, key) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', `attributes[${ key }]`);
      input.setAttribute('value', value);
      formNode.parentNode.insertBefore(input, formNode.nextSibling);
    });
  }

  select_flexible_plan(id) {
    this.selected_flexible_plan = window.plan_details.find(program=>{
      return program.id == id;
    });
    this.render();
  }

  select_program(id) {
    const is_vegan = window.plan_details.some(p => p.plan_id == id && p.handle == 'vegan-program');
    this.program_type = is_vegan && this.program_type == 'Full Program' ? 'Lunches & Dinners' : this.program_type;
    
    this.selected_structured_plan = window.plan_details.find(program=>{
      return program.plan_id == id 
        && program.type == this.program_type 
        && program.duration == this.program_duration 
        && program.snack_count == this.plan_snacks
    });
    this.selected_variant = this.selected_structured_plan.id;
    this.render();
  }

  update_duration(d) {
    this.program_duration = d;
    this.select_program(this.selected_structured_plan.plan_id);
  }

  update_type(d) {
    this.program_type = d;
    this.select_program(this.selected_structured_plan.plan_id);
  }

  update_snacks(d) {
    this.plan_snacks = d;
    this.select_program(this.selected_structured_plan.plan_id);
  }

  async clear_cart() {
    try {
      await fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST'
      });
      // Clear cart attributes (set each attribute value to null)
      const response = await fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
      });
      const cart = await response.json();
      const newAttributes = Object.keys(cart.attributes).reduce((newAttr, key) => {
        newAttr[key] = null;
        return newAttr;
      }, {});
      const result = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes: newAttributes })
      });
      return result.json();
    }
    catch(error) {
      console.error('Error:', error);
    }
  }

  async add_to_cart(formData) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      return response.json();
    }
    catch(error) {
      console.error('Error:', error);
    }
  }

  check_type(e){
    const type = e.srcElement.value || e.srcElement.previousElementSibling?.value;
    if(type != 'Full Program') return;
    const is_vegan = window.plan_details.some(p => p.plan_id==this.selected_structured_plan.plan_id && p.handle == 'vegan-program');
    if(is_vegan && ['mouseenter', 'click'].includes(e.type)){
      document.querySelector(".js-prod-description").innerHTML = 'This option is currently unavailable.';
    } else {
      const prog = document.querySelector(".single-plan-product[data-product-id='"+this.selected_structured_plan.plan_id+"']");
      document.querySelector(".js-prod-description").innerHTML = prog?.getAttribute("data-description")||'';
    }
  }
}

window.addEventListener("DOMContentLoaded",event=>{
	const selector = new PlanSelector();
});

window.addEventListener("popstate", e => {
  window.location.reload();
});
